import React, { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { Button } from "./ui/button";
import { useQuoteModal } from "@/hooks/useQuoteModal";

export const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { openModal } = useQuoteModal();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full transition-all duration-300">
      {/* Slim top bar - minimal info only */}
      <div className="bg-slate-950 text-white text-xs py-2 px-4">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <span className="text-slate-300">
            Davie, FL — <span className="text-amber-400 font-semibold">Same-Day Service Available</span>
          </span>
          <a
            href="tel:9542808090"
            className="text-amber-400 font-bold hover:text-amber-300 transition-colors flex items-center gap-1.5"
          >
            <Phone className="w-3.5 h-3.5" /> (954) 280-8090
          </a>
        </div>
      </div>

      {/* Main navigation header */}
<div
        className={`bg-white transition-all duration-300 border-b border-slate-100 ${
          isScrolled ? "shadow-sm py-0.5" : "py-1"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
          <a href="#" className="flex items-center focus:outline-none">
            <Logo />
          </a>

          {/* Desktop Links - simplified to 4 core items */}
          <nav className="hidden lg:flex items-center gap-8">
            <a
              href="#services"
              className="text-sm font-semibold text-slate-700 hover:text-primary transition-colors"
            >
              Services
            </a>
            <a
              href="#about"
              className="text-sm font-semibold text-slate-700 hover:text-primary transition-colors"
            >
              About
            </a>
            <a
              href="#reviews"
              className="text-sm font-semibold text-slate-700 hover:text-primary transition-colors"
            >
              Reviews
            </a>
            <a
              href="#booking"
              className="text-sm font-semibold text-slate-700 hover:text-primary transition-colors"
            >
              Book Now
            </a>
          </nav>

          {/* Desktop Right CTA */}
          <div className="hidden lg:flex items-center gap-3">
            <a
              href="tel:9542808090"
              className="flex items-center gap-2 text-slate-900 font-bold hover:text-primary transition-colors"
            >
              <Phone className="w-5 h-5" />
              <span>(954) 280-8090</span>
            </a>
            <Button onClick={openModal} className="font-bold bg-primary hover:bg-rose-600 text-white shadow-md shadow-rose-500/20">
                Free Quote
              </Button>
          </div>

          {/* Mobile menu trigger */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 text-slate-700 rounded-lg hover:bg-slate-100 focus:outline-none"
            aria-label="Toggle navigation menu"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Drawer - clean & simple */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-b border-slate-200 shadow-lg">
          <nav className="px-4 py-4 flex flex-col gap-1">
            <a
              href="#services"
              onClick={() => setMobileMenuOpen(false)}
              className="text-base font-semibold text-slate-800 hover:text-primary py-3 px-3 rounded-lg hover:bg-slate-50 transition-colors"
            >
              Services
            </a>
            <a
              href="#about"
              onClick={() => setMobileMenuOpen(false)}
              className="text-base font-semibold text-slate-800 hover:text-primary py-3 px-3 rounded-lg hover:bg-slate-50 transition-colors"
            >
              About Us
            </a>
            <a
              href="#reviews"
              onClick={() => setMobileMenuOpen(false)}
              className="text-base font-semibold text-slate-800 hover:text-primary py-3 px-3 rounded-lg hover:bg-slate-50 transition-colors"
            >
              Reviews
            </a>
            <a
              href="#booking"
              onClick={() => setMobileMenuOpen(false)}
              className="text-base font-semibold text-slate-800 hover:text-primary py-3 px-3 rounded-lg hover:bg-slate-50 transition-colors"
            >
              Book Online
            </a>
            
            <div className="border-t border-slate-100 mt-2 pt-4 flex flex-col gap-2">
              <a
                href="tel:9542808090"
                className="flex items-center justify-center gap-2 bg-amber-400 text-slate-950 font-bold py-3 rounded-lg hover:bg-amber-500 transition-colors"
              >
                <Phone className="w-5 h-5" /> Call (954) 280-8090
              </a>
              <button
                onClick={() => { setMobileMenuOpen(false); openModal(); }}
                className="flex items-center justify-center gap-2 bg-primary text-white font-bold py-3 rounded-lg"
              >
                Get Free Quote
              </button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};
